import { Component } from "react";

class NavigationGuard extends Component {
    componentDidMount() {
        this.currentUrl = window.location.href;
        window.addEventListener("beforeunload", this.onBeforeUnload);
        window.addEventListener("popstate", this.onPopState);
        document.addEventListener("click", this.onClickCapture, true);
    }

    componentDidUpdate() {
        if (!this.shouldBlock()) {
            this.currentUrl = window.location.href;
        }
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onBeforeUnload);
        window.removeEventListener("popstate", this.onPopState);
        document.removeEventListener("click", this.onClickCapture, true);
    }

    get message() {
        return this.props.message || "You have unsaved changes. Leave this page?";
    }

    shouldBlock = () => {
        if (typeof this.props.when === "function") {
            return Boolean(this.props.when());
        }

        return Boolean(this.props.when);
    };

    confirm = () => {
        return !this.shouldBlock() || window.confirm(this.message);
    };

    onBeforeUnload = (event) => {
        if (!this.shouldBlock()) return;

        event.preventDefault();
        event.returnValue = "";
    };

    onPopState = () => {
        if (this.confirm()) {
            this.currentUrl = window.location.href;
            return;
        }

        window.history.pushState(null, "", this.currentUrl);
    };

    onClickCapture = (event) => {
        if (!this.shouldBlock() || event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const anchor = event.target?.closest?.("a[href]");
        if (!anchor || anchor.target || anchor.hasAttribute("download")) return;

        const url = new URL(anchor.href, window.location.href);
        if (url.origin !== window.location.origin || url.href === window.location.href) return;
        if (url.pathname === window.location.pathname && url.search === window.location.search) return;

        if (!this.confirm()) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation?.();
        }
    };

    render() {
        return null;
    }
}

export default NavigationGuard;
